import classNames from "classnames";
import React from "react";

import { IProduct } from "../../../models/catalogue.interfaces";
import {
    PriceType,
    getProductPrice,
    isProductPriceDiscounted,
} from "../../../utils/catalogue";
import { money } from "../../../utils/format";
import {
    getCheapestProductVariant,
    sortProductsByPrice,
} from "../../../utils/sorting";

interface IProps {
    products: IProduct[];
    isSelected: boolean;
    onProductSelect: () => void;
}

export const ProductCompareSelectionTile = ({
    products,
    isSelected,
    onProductSelect,
}: IProps): React.ReactNode => {
    const buildPrice = (): React.ReactNode => {
        if (products.length <= 0) {
            return null;
        }

        const cheapestParent = sortProductsByPrice(products)[0];
        const cheapestProduct = getCheapestProductVariant(cheapestParent);
        const isDiscounted = isProductPriceDiscounted(cheapestProduct.price);
        let priceElem: React.JSX.Element;
        if (isDiscounted) {
            priceElem = (
                <>
                    <div className="strikethru">
                        {money(
                            getProductPrice(cheapestProduct.price, {
                                priceType: PriceType.RETAIL,
                                includePostDiscountAddons: true,
                                quantity: 1,
                            }),
                        )}
                    </div>
                    <h3 className="discounted">
                        {money(
                            getProductPrice(cheapestProduct.price, {
                                priceType: PriceType.COSMETIC_EXCL_TAX,
                                includePostDiscountAddons: true,
                                quantity: 1,
                            }),
                        )}
                    </h3>
                </>
            );
        } else {
            priceElem = (
                <h3>
                    {money(
                        getProductPrice(cheapestProduct.price, {
                            priceType: PriceType.COSMETIC_EXCL_TAX,
                            includePostDiscountAddons: true,
                            quantity: 1,
                        }),
                    )}
                </h3>
            );
        }
        return (
            <div className="price">
                <p>Starting At</p>
                {priceElem}
            </div>
        );
    };

    const buildSelectButton = (): React.ReactNode => {
        const buttonText = isSelected ? "Selected" : "Select";
        const btnClasses = classNames({
            "button": true,
            "button--secondary": isSelected,
        });
        return (
            <button className={btnClasses} onClick={onProductSelect}>
                {buttonText}
            </button>
        );
    };

    return (
        <>
            {buildPrice()}
            {buildSelectButton()}
        </>
    );
};
